import { render, staticRenderFns } from "./customerFollowUp.vue?vue&type=template&id=2230b150&scoped=true"
import script from "./customerFollowUp.vue?vue&type=script&lang=js"
export * from "./customerFollowUp.vue?vue&type=script&lang=js"
import style0 from "./customerFollowUp.vue?vue&type=style&index=0&id=2230b150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230b150",
  null
  
)

export default component.exports